<template>
  <div>
    <TitleCard :titleMsg1="titleMsg1" :titleMsg2="titleMsg2" :titleMsg3="titleMsg3" :titleMsg4="titleMsg4"></TitleCard>

    <a-card class="all-card-style ">

      <a-form-model  :rules="FormRules" ref="workOrder"  :model="workModel"  :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">

                <a-form-model-item prop="cTaskName" label="工单名称"  class="ant-form-item2">
          <a-input v-model="workModel.cTaskName" placeholder="请输入" :rows="3" />
        </a-form-model-item>

        <a-form-model-item prop="cPlatformID" label="所属项目"  class="ant-form-item2 ">
          <a-select v-model="workModel.cPlatformID" @change="platformSelect"  class="ant-form-item3 ">
            <a-select-option v-for="(item,index) in platformSelectItems" :value="item.ID">
              {{item.cPlatformName}}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="cSceneID" label="所属场地" class="ant-form-item2 " >
          <a-select v-model="workModel.cSceneID"  @change="sceneformSelect" class="ant-form-item3 " >
            <a-select-option v-for="(item,index) in sceneformSelectItems" :value="item.ID">
              {{item.cSceneName}}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item prop="cOptUser"  label="实施人员"  class="ant-form-item2">
         <a-select
          placeholder="请选择" v-model="workModel.cOptUser"   class="ant-form-item3"
          >

           <a-select-option v-for="(item,index) in userSelectItems" :value="item.ID">
             {{item.cUserName}}
           </a-select-option>

        </a-select>
          <!-- <a-input v-model="model.cTaskContent" placeholder="请输入" :rows="3" /> -->
        </a-form-model-item>
                <a-form-model-item  prop="cTaskContent"   label="工作内容"  class="ant-form-item2">
          <a-input v-model="workModel.cTaskContent" placeholder="请输入" :rows="3" />
        </a-form-model-item>

        <a-form-model-item  prop="dStartDate"  label="开始时间"  class="ant-form-item2">
          <a-date-picker v-model="workModel.dStartDate" placeholder="请选择日期" />
        </a-form-model-item>
         <a-form-model-item  prop="dEndDate"  label="结束时间"  class="ant-form-item2">
          <a-date-picker v-model="workModel.dEndDate" placeholder="请选择日期" />
        </a-form-model-item>



        <a-form-model-item :wrapper-col="{ span: 12, offset: 2 }">
          <a-button type="primary" html-type="button" @click="SaveForms">
            确定
          </a-button>
        </a-form-model-item>

      </a-form-model>


    </a-card>
  </div>
</template>

<script>
  import TitleCard from '@/components/TitleCard.vue'
  import { _getEntPlatFormData,_getAllUser } from '@/common/request'

  export default {
    name: 'diseaseForm',
    components: {
      TitleCard
    },
    data() {
      return {
        platformSelectItems:[],
        sceneformSelectItems:[],
        userSelectItems:[],
        queryPlatformInfo:{
          cEntID:"",
          keyword:""
        },
        titleMsg1: "生产管理",
        titleMsg2:'工单管理',
        titleMsg3:'工单管理',
        titleMsg4:'工单管理',
        workModel:{},
        cEntID:"",
        FormRules:{
          cTaskName: [
            { required: true, message: '请输入工单名称', trigger: 'blur' }
          ],
          cPlatformID:[
            { required: true, message: '请选择所属项目', trigger: 'change' }
          ],
          cSceneID:[
            { required: true, message: '请选择所属场地', trigger: 'change' }
          ],
          cOptUser:[
            { required: true, message: '请选择实施人员', trigger: 'change' }
          ],

          cTaskContent:[
            { required: true, message: '请输入工作内容', trigger: 'blur' }
          ],
        dStartDate:[
          { required: true, message: '请选择开始时间', trigger: 'change' }
        ],
        dEndDate:[
          { required: true, message: '请选择结束时间', trigger: 'change' }
        ]
        }
      }
    },
    mounted () {
      let that=this;
      that.queryPlatformInfo.cEntID=that.$store.getters.User.enterprise.ID;
      that.workModel.cEntID=that.$store.getters.User.enterprise.ID;

      if (that.$route.params.sceneId){
       // that.workModel.sceneId=that.$route.params.sceneId;
      }
      if (that.$route.params.ID){
        that.workModel.ID=that.$route.params.ID;
        that.HandleDetail();
      }

      that.workModel.cSceneID=that.$store.getters.SCene.ID;
      that.workModel.cSceneName=that.$store.getters.SCene.cSceneName;
      that.getEntPlatFormData()
      that.getAllUser();console.log('getAllUser',111111);
    },

    methods:{
      platformSelect(){

        this.getSceneData()
      },
      async getAllUser(){
        console.log('getAllUser',2222222);
        let that=this
        let res=await _getAllUser(this,this.queryPlatformInfo);
        console.log(res);
        if(res.code=='200'){
          that.userSelectItems=res.obj.list
        }
      },

      /*获取项目列表*/
      async getEntPlatFormData(){
        var that=this
        let res=await  _getEntPlatFormData(this,this.queryPlatformInfo)


        if(res.data.data.code=="200"){

          that.platformSelectItems=res.data.data.obj.list
          if(that.platformSelectItems.length>0) {
            that.workModel.cPlatformID=that.platformSelectItems[0].ID

            this.getSceneData()
          }
        }

      },
      async getSceneData(){
        var that=this
        let res=await that.$http.post('EntSceneInfo/List',{cSystemCode:'节水灌溉',cPlatformID:that.workModel.cPlatformID})

        if(res.data.code=="200"){

          that.sceneformSelectItems=res.data.obj.list

          if(that.sceneformSelectItems.length>0) {
            that.workModel.cSceneID=that.sceneformSelectItems[0].ID
            that.workModel.cSceneName=that.sceneformSelectItems[0].cSceneName

          }
        }

      },
      async getKeySecretData(){
        var that=this
        let res=await that.$http.post('HkCamera/GetKeySecretList',{cEntID:that.$store.getters.User.enterprise.ID})

        if(res.data.code=="200"){

          that.AppKeySelectItems=res.data.obj.list

          if(that.AppKeySelectItems.length>0) {
            that.model.AppKey=that.AppKeySelectItems[0].cAppId
            that.model.APPSecret=that.AppKeySelectItems[0].cAppPwd

          }
        }

      },
      sceneformSelect(){
        let that=this;
        that.workModel.cSceneName=this.sceneformSelectItems.filter(s=>s.ID==that.workModel.cSceneID)
      },
      async HandleDetail () {
        var that = this;

        let res = await that.$http.post('EntWorkOrderTask/FindById/' + that.workModel.ID, null)

        if (res.data.code == "200") {
          that.workModel = res.data.obj.data;
        } else {

        }
      },
      async SaveForms () {
        let that = this;
        let form=that.$refs['workOrder'];
        that.workModel.cSystemCode='节水灌溉';
        form.validate(async valid => {

          if (valid) {
            let res = await that.$http.post('EntWorkOrderTask/Save', that.workModel)
            if (res.data.code == "200") {
              that.$message.success('保存成功!')
              that.$router.push({name:'WorkorderManagementlist'});
            } else {
              that.$message.error(res.data.message)

            }
          } else {
            that.$message.error('校验失败!')
          }
        });
      }
    }
  }
</script>


